const channeldescription = [
    {
        channelname:"CoderDost",
        channelId:"@coderdost",
        subscription:"62.9K subscribers",
        videos:"399 videos",
        channelLogo:"https://yt3.googleusercontent.com/m-FbG7zwy9uuelkhgj4BqkpSGuL29FCDaibjs6P5KmmACUgm5N4iAk2SbJNuHK7dBqUEvSEf=s176-c-k-c0x00ffffff-no-rj",
        link:"https://www.youtube.com/coderdost"
    },
    {
        channelname:"Developers Corner",
        channelId:"@developerscorner",
        subscription:"18K subscribers",
        videos:"99 videos",
        channelLogo:"https://yt3.googleusercontent.com/JL71VpQoztJzy3adUx6Gwein3Bryy74DC6h93BDO3r3R6i5quT-CqgfBJuHql6_TCRkk95rz8w=s176-c-k-c0x00ffffff-no-rj",
        link:"https://www.youtube.com/@developerscorner"
    },
    {
        channelname:"6 Pack Programmer",
        channelId:"@6PackProgrammer",
        subscription:"65.9K subscribers",
        videos:"240 videos",
        channelLogo:"https://yt3.googleusercontent.com/fh9PW3GdzRaGngR0IDM4cLun7vixMPtOc0Mx-ia-VvR3zsvSNsJaPR2koYMDT1iQgUQNlwXuwg=s176-c-k-c0x00ffffff-no-rj",
        link:"https://www.youtube.com/@6packprogrammer"
    },
    {
        channelname:"Online Tutorials",
        channelId:"@OnlineTutorialsYT",
        subscription:"921K subscribers",
        videos:"2.2K videos",
        channelLogo:"https://yt3.googleusercontent.com/ytc/APkrFKYghqbtwuEh8SyJ5hqmCazX2R6z-spBCTro_apBuA=s176-c-k-c0x00ffffff-no-rj",
        link:"https://www.youtube.com/@OnlineTutorialsYT"
    },
    {
        channelname:"Codehal",
        channelId:"@codehal",
        subscription:"114K subscribers",
        videos:"126 videos",
        channelLogo:"https://yt3.googleusercontent.com/SZDSSBxcuZPWay3WyQOV1uBnAsRQ4_MlpomNMdnU8BCudpaiyMDFs2VeUqzgson0Uzb1biGMlKg=s176-c-k-c0x00ffffff-no-rj",
        link:"https://www.youtube.com/@codehal"
    },
    {
        channelname:"ZAINKEEPSCODE",
        channelId:"@ZAINKEEPSCODE",
        subscription:"49.6K subscribers",
        videos:"24 videos",
        channelLogo:"https://yt3.googleusercontent.com/zWgsdxUBVdEmCJUReDmF-s2HAPkdXttVVeuajRAj9kNpEMpOCbrucJZ3hlCkxUNmwQ4xdic-o3U=s176-c-k-c0x00ffffff-no-rj",
        link:"https://www.youtube.com/@ZAINKEEPSCODE",
    },
    {
        channelname:"Daily Tuition",
        channelId:"@DailyTuition",
        subscription:"167K subscribers",
        videos:"748 videos",
        channelLogo:"https://yt3.googleusercontent.com/hkRZlmV18W3wm8DlqOZaQHe-g-h8ugcsIdeSk6ZpCOyhOXf1ReGTseiNi8ek92Waosv4r32G=s176-c-k-c0x00ffffff-no-rj",
        link:"https://www.youtube.com/@DailyTuition"
    },
    {
        channelname:"Thapa Technical",
        channelId:"@ThapaTechnical",
        subscription:"621K subscribers",
        videos:"1.8K videos",
        channelLogo:"https://yt3.googleusercontent.com/ytc/APkrFKZUsJhMFbLR3F9t3-uWErufcVlPQbe2Kg0OFRKKPw=s176-c-k-c0x00ffffff-no-rj",
        link:"https://www.youtube.com/@ThapaTechnical"
    },
]

export default channeldescription